import useTranslation from "next-translate/useTranslation";
import { AiFillApple } from "react-icons/ai";

import styled from "styled-components";
import Or from "../ReuseableCompos/Or";
const SignWith = () => {
  const { t } = useTranslation("common");

  return (
    <>
      <StyledContinueWith className="d-flex flex-column align-items-center mb-4">
        <a
          className="btn btn-block bs-facebook btn-lg mt-3 btn-outline-primary text-facebook"
          href="#"
        >
          <i className="ai-facebook fs-xl me-1 text-facebook"></i>{" "}
          <span className="">{t(`signin_facebook`)} </span>
        </a>
        <a
          className="btn btn-block bs-twitter btn-lg mt-3 btn-outline-primary text-twitter"
          href="#"
        >
          <i className="ai-twitter fs-xl me-2 text-twitter"></i>{" "}
          <span className=""> {t(`signin_twitter`)}</span>
        </a>

        <a
          className="btn btn-block bs-google btn-lg mt-3 btn-outline-primary"
          href="#"
        >
          <i className="ai-google fs-xl me-2 text-google"></i>{" "}
          <span className="">{t(`signin_google`)}</span>
        </a>

        <a
          className="btn btn-block bs-apple btn-lg mt-3 btn-outline-primary "
          href="#"
        >
          <i>
            <AiFillApple
              className="pb-1 text-apple"
              style={{ fontSize: "2rem" }}
            />
          </i>{" "}
          <span className="">{t(`signin_apple`)}</span>
        </a>
      </StyledContinueWith>

      <Or  />
    </>
  );
};

export default SignWith;


const StyledContinueWith = styled.div`
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
    /* color: #fff; */
    &:hover {
      color: #fff;
      border-color: unset;
    }
    span {
      /* */
      text-align: center;
      width: 70%;
      display: flex;

      justify-content: flex-start;
    }
    i {
      width: 30%;
      display: flex;
      justify-content: flex-end;
      /* padding-right: 5%; */
    }
  }
  .btn-outline-primary {
    /* color: #737491; */
  }
  .btn-outline-primary:hover i,
  .btn-outline-primary:hover i svg {
    color: #fff !important;
  }
`;
